import React from 'react';
import { motion } from 'framer-motion';
import { Search, Terminal, ArrowRight, Circle } from 'lucide-react';

const OffensiveServices = () => {
  const services = [
    {
      title: "Services OSINT",
      icon: Search, // Icone de recherche
      desc: "Investigation numérique et collecte d'informations pour identifier vos fuites de données.",
      features: ["Audit personnel", "Audit Entreprise", "Dirigeants / RSSI"],
      linkText: "Découvrir l'offre OSINT",
    },
    {
      title: "Services Pentest",
      icon: Terminal, // Icone terminal exacte de ta capture
      desc: "Simulation d'attaques réelles pour tester vos barrières et corriger les vulnérabilités.",
      features: ["Tests d'intrusion Web & Mobile", "Audit technique"],
      linkText: "Découvrir l'offre Pentest",
    }
  ];

  return (
    <section className="w-full bg-[#F6FAFD] py-12 px-8 md:py-16 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        
        {/* Header Compact - Titre réduit à 36px pour gagner de la place */}
        <motion.div 
          initial={{ opacity: 0, y: 15 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-10"
        >
          <span className="text-[#4A7FA7] text-[12px] font-black uppercase tracking-[0.3em] mb-2 block">
            Nos Expertises
          </span>
          <h2 className="text-[#0A1931] text-[28px] md:text-[36px] font-black leading-tight font-inter">
            Services de cybersécurité offensive
          </h2>
          <div className="w-10 h-1 bg-[#4A7FA7] mx-auto mt-3 rounded-full" />
        </motion.div>

        {/* Grille de Cartes - Espacement réduit */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {services.map((service, i) => {
            const Icon = service.icon;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                whileHover="hover"
                className="relative group cursor-pointer"
              >
                {/* Lueur arrière discrète */}
                <div className="absolute inset-0 bg-[#B3CFE5]/10 blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-[1.5rem]" />

                <div className="relative bg-white border border-[#B3CFE5]/30 p-6 md:p-8 rounded-[1.5rem] h-full flex flex-col justify-between transition-all duration-300 hover:border-[#4A7FA7] hover:shadow-lg">
                  
                  <div>
                    {/* Icône compacte */}
                    <div className="w-12 h-12 bg-[#B3CFE5]/20 rounded-xl flex items-center justify-center text-[#4A7FA7] mb-6 group-hover:bg-[#4A7FA7] group-hover:text-white transition-all duration-300">
                      <Icon size={24} strokeWidth={2} />
                    </div>

                    <h3 className="text-[#0A1931] text-[22px] font-black mb-3 font-inter">
                      {service.title}
                    </h3>

                    <p className="text-[#1A3D63]/70 text-[15px] leading-relaxed mb-6 font-medium max-w-sm">
                      {service.desc}
                    </p>

                    {/* Liste de features sur 2 colonnes pour réduire la hauteur */}
                    <ul className="grid grid-cols-2 gap-3 mb-8">
                      {service.features.map((item, idx) => (
                        <li key={idx} className="flex items-center gap-2 text-[#1A3D63] font-bold text-[13px]">
                          <Circle size={6} className="text-[#4A7FA7]" fill="#B3CFE5" strokeWidth={0} />
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Lien CTA discret */}
                  <div className="inline-flex items-center gap-2 text-[#4A7FA7] font-black text-[14px]">
                    <span className="relative overflow-hidden py-1">
                      {service.linkText}
                      <span className="absolute bottom-0 left-0 w-full h-0.5 bg-[#4A7FA7] translate-x-[-105%] group-hover:translate-x-0 transition-transform duration-300" />
                    </span>
                    <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform duration-300" />
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default OffensiveServices;